import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { userApi } from '../../services/userApi';
import { CreateUser } from '../../dtos/Users/index';
import { userKeys } from './useGetUser';

export function useCreateUser() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateUser) => userApi.create(data),
    onSuccess: (response) => {
      if (response.isSuccess) {
        toast.success('Successfully created user');
        queryClient.invalidateQueries({ queryKey: userKeys.all });
      } else {
        toast.error(`Error: ${response.errorMessage || 'Failed to create user'}`);
      }
    },
    onError: (error: Error) => {
      toast.error(`Error: ${error.message || 'Failed to create user'}`);
    },
  });
}
